import { Link } from 'react-router-dom';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Michael T.',
      role: 'Business Executive',
      rating: 5,
      text: 'Custom Clothiers transformed my wardrobe. The attention to detail and perfect fit of my custom suits is unmatched. The house call service made the entire process incredibly convenient.',
      image: 'https://ui-avatars.com/api/?name=Michael+T&background=C4A962&color=fff&size=80',
    },
    {
      name: 'David C.',
      role: 'Attorney',
      rating: 5,
      text: 'After years of buying off-the-rack, I finally experienced true custom tailoring. The craftsmanship is exceptional, and the fit is perfect. Worth every penny.',
      image: 'https://ui-avatars.com/api/?name=David+C&background=C4A962&color=fff&size=80',
    },
    {
      name: 'Robert M.',
      role: 'Entrepreneur',
      rating: 5,
      text: 'The team at Custom Clothiers is professional, knowledgeable, and truly cares about getting every detail right. My custom shirts fit better than anything I\'ve ever owned.',
      image: 'https://ui-avatars.com/api/?name=Robert+M&background=C4A962&color=fff&size=80',
    },
    {
      name: 'James W.',
      role: 'Real Estate Developer',
      rating: 5,
      text: 'Outstanding service from start to finish. The fabric selection is incredible, and the tailors really know their craft. I\'ve recommended them to all my colleagues.',
      image: 'https://ui-avatars.com/api/?name=James+W&background=C4A962&color=fff&size=80',
    },
    {
      name: 'Christopher L.',
      role: 'Financial Advisor',
      rating: 5,
      text: 'Custom Clothiers delivers on quality and service. The custom blazers I ordered fit perfectly and look amazing. The entire experience exceeded my expectations.',
      image: 'https://ui-avatars.com/api/?name=Christopher+L&background=C4A962&color=fff&size=80',
    },
    {
      name: 'Daniel B.',
      role: 'Physician',
      rating: 5,
      text: 'As someone with a busy schedule, the house call service was perfect. The quality of the custom suits is exceptional, and the fit is absolutely perfect.',
      image: 'https://ui-avatars.com/api/?name=Daniel+B&background=C4A962&color=fff&size=80',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join hundreds of satisfied clients who trust Custom Clothiers for their tailoring needs
          </p>
          <div className="flex items-center justify-center mt-6 space-x-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#C4A962] text-2xl"></i>
              ))}
            </div>
            <span className="text-gray-600 font-semibold">4.9/5 from 127+ reviews</span>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              {/* Rating */}
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C4A962] text-lg"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full mr-4"
                />
                <div>
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link
            to="/reviews"
            className="inline-flex items-center text-[#C4A962] font-semibold hover:text-[#B39952] transition-colors"
          >
            Read More Reviews
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;